import { render, staticRenderFns } from "./AboutHero.vue?vue&type=template&id=ee5423b6&scoped=true&"
import script from "./AboutHero.vue?vue&type=script&lang=js&"
export * from "./AboutHero.vue?vue&type=script&lang=js&"
import style0 from "./AboutHero.vue?vue&type=style&index=0&id=ee5423b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5423b6",
  null
  
)

export default component.exports